import { UppyOptions } from '@uppy/core'

import { OptionArgs } from './type'

const webcamLocale = {
  strings: {
    pluginNameCamera: 'カメラ',
    noCameraTitle: 'カメラが利用できません',
    noCameraDescription: '写真を撮影するには、カメラデバイスを接続してください',
    recordingStoppedMaxSize:
      'ファイルサイズが制限に達したため、録画を停止しました',
    submitRecordedFile: '録画したファイルを送信',
    discardRecordedFile: '録画したファイルを破棄',
    smile: 'スマイル！',
    takePicture: '写真を撮影',
    startRecording: '録画開始',
    stopRecording: '録画停止',
    recordingLength: '録画時間: %{recording_length}秒',
    allowAccessTitle: 'カメラへのアクセスを許可してください',
    allowAccessDescription:
      '写真を撮影するには、このサイトへのカメラアクセスを許可してください',
  },
}

export const option = ({
  id,
  maxFileSize = 10 * 1024 * 1024, // 10MB
  allowedFileTypes = ['application/pdf', 'image/png', 'image/jpeg'],
  allowedFileExtensions = ['PDF', 'PNG', 'JPEG'],
  allowMultipleUploads = true,
  maxNumberOfFiles = null,
}: OptionArgs): UppyOptions => {
  return {
    id,
    debug: process.env.NODE_ENV !== 'production',
    autoProceed: false,
    allowMultipleUploads,
    restrictions: {
      maxFileSize,
      maxNumberOfFiles,
      minNumberOfFiles: null,
      allowedFileTypes,
    },
    locale: {
      strings: {
        youCanOnlyUploadFileTypes: `許可されているファイル形式は、${allowedFileExtensions.join(
          '/'
        )}です`,
        exceedsSize: 'ファイルサイズが大きすぎます。1ファイル最大%{size}',
        youCanOnlyUploadX: '%{smart_count} ファイル数のみアップロード可能です',
        importFrom: 'アップロード',
        importFiles: 'アップロード方法',
        cancel: 'キャンセル',
        ...webcamLocale.strings, // Webcam用の文字列を追加
      },
    },
  }
}
